import React from 'react';
import { Heading, type HeadingT } from './Heading';

export const H3 = (props: HeadingT) => (
  <Heading
    as="h3"
    fontSize={['125', null, null, '175']}
    useAnchors={false}
    {...props}
  />
);
